import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { GeneralInformation } from "../template_offering_details_base";
import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useWerqwiseAnalytics } from "./werqwise_analytics";
import { partnerConfig, testimonials } from "./werqwise_partner_config";

const Theme = lazyWithRetry(() => import("./werqwise_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer: "We are open from 9 AM to 5:30 PM.",
  },

  {
    question: "Can I cancel my day pass purchase?",
    answer: "Unfortunately, the Lounge Day Pass is non-refundable.",
  },

  {
    question: "Can I change the date of my day pass booking?",
    answer:
      "Yes. Please either call us or reply to the confirmation email and we will take care of it.",
  },

  {
    question: "Can I share my pass with other people?",
    answer:
      "No. The Lounge Day Pass is for personal use only and is not transferable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer:
      "Yes, the meeting rooms are charged at an hourly rate. Please contact the front desk for availability and pricing options.",
  },

  {
    question: "Can I use the printer?",
    answer:
      "Yes, please get in touch with the front desk and we will assist you.",
  },

  {
    question:
      "Can I meet with clients or bring a guest into the Werqwise lounges and common area?",
    answer:
      "Your Day Pass is for one person only and doesn’t cover guests. You will have to purchase a Day Pass for each of your guests.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "The kitchen, refrigerator and microwave is available for your use.",
  },
  {
    question: "Do you offer coffee, tea, or water?",
    answer: "We offer freshly brewed coffee.",
  },
];

const generalInfo: GeneralInformation = {
  title: `General information and cancellation policy`,
  description: "",
  bulletPoints: [
    {
      point: "Cancellation and Changes",
      text: "You may cancel your reservation 24 hours before the reservation begins.",
    },
    {
      point: "Opening hours",
      text: "Access to the building will be granted between 9 AM to 5:30 PM. Please note that it is not possible to access the building before 9 AM.",
    },
    {
      point: "Attendees",
      text: "Your office day pass gives access to a private office. Be sure to select the right capacity that fits your team.",
    },
    {
      point: "Health and safety",
      text: "We've updated our space to help you make better choices. From installing our new temperature gate to adding hand sanitizer fixtures, we have added a variety of different ways for you to stay healthy and clean.",
    },
  ],
};

export function OfferingWerqwiseDayPass() {
  useWerqwiseAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Spread out in our accommodating, well ventilated, and socially distanced lounge. We've created unique work areas catered for all types of thinkers. ​Enjoy all the member amenities for the day.`,
          faqs,
          testimonials: testimonials,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
